/**
 * File messageBox.js
 * Description: File dùng trung gian để gọi thông báo
 * creatd by: nntam - 16/8/2019
 */
import Vue from 'vue';
import MsMessageBox from '@/components/msMessageBox/MsMessageBox';
import i18n from '@/i18n/i18n';
class MessageBox {
	show(option) {
		let promise = new Promise((resolve, reject) => {
			const me = this;
			// cấu hình button mặt định
			let btnConfigDefault = [
				{
					key: 'Download',
					hasBtn: false,
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.Download')}`,
					typeButton: 'primary',
					focus: true
				},
				{
					key: 'Cancel',
					hasBtn: false,
					target: 'Left',
					text: `${i18n.t('i18nCommon.Cancel')}`,
					typeButton: 'secondary'
				},
				{
					key: 'Close',
					hasBtn: false,
					target: 'Center',
					text: `${i18n.t('i18nCommon.Close')}`,
					typeButton: 'primary'
				},
				{
					key: 'Yes',
					hasBtn: false,
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.Agree')}`,
					typeButton: 'primary',
					focus: true
				},
				{
					key: 'Delete',
					hasBtn: false,
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.Delete')}`,
					typeButton: 'delete',
					focus: true
				},
				{
					key: 'No',
					hasBtn: false,
					target: 'RightFirst',
					text: `${i18n.t('i18nCommon.Cancel')}`,
					typeButton: 'secondary'
				},
				{
					key: 'UnConnect',
					hasBtn: false,
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.DisConnect')}`,
					typeButton: 'primary',
					focus: true
				},
				{
					key: 'PermissionGuild',
					hasBtn: false,
					target: 'Left',
					text: `${i18n.t('i18nCommon.PermissionGuild')}`,
					typeButton: 'nine',
					icon: 'mi-new mi-20 mi-question-blue-large'
				},
				{
					key: 'UploadXml',
					hasBtn: false,
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.UploadXml')}`,
					typeButton: 'secondary',
					focus: true
				}
			];

			// merge cấu hình người dùng với cấu hình mặc định
			// nntam - 16/04/2020: bổ sung thêm truyền vào loại button (typeButton)
			if (option.btnConfig != null) {
				btnConfigDefault.forEach(element => {
					element.hasBtn = false;
					option.btnConfig.forEach(e => {
						if (element.key === e.key) {
							element.target = e.target;
							element.hasBtn = true;
							element.text = e.text ? e.text : element.text;
							element.focus = e.focus;
							element.typeButton = e.typeButton ? e.typeButton : element.typeButton;
							element.callback = e.callback;
						}
					});
				});
			}

			// gán lại cấu hình mặc định với các tham số người dùng gửi vào
			let optionDefault = {
				message: option.message,
				textAlignMessage: option.textAlignMessage,
				messageDetail: option.messageDetail ? option.messageDetail : '',
				icon: option.icon == false ? false : option.icon ? option.icon : 'mi-icon-waring-55',
				line: option.line == false ? false : true,
				btnConfig: btnConfigDefault,
				closeMessageAfterLink: option.closeMessageAfterLink,
				close: option.close,
				width: option.width ? option.width : '432px',
				title: option.title ? option.title : null,
				isClose: option.isClose ? option.isClose : false,
				hiddenBorderHeader: option.hiddenBorderHeader ? option.hiddenBorderHeader : false,
				classMessageContent: option.classMessageContent ? option.classMessageContent : '',
				noClassPaddingBottom: option.noClassPaddingBottom ? option.noClassPaddingBottom : '',
				classContent: option.classContent ? option.classContent : '',
				maxHeight: option.maxHeight ? option.maxHeight : '',
				maxHeightMessage: option.maxHeightMessage ? option.maxHeightMessage : '',
				optionsCustom: option.optionsCustom ? option.optionsCustom : {}
			};

			let zz = new Vue({
				i18n: i18n,
				el: '#message-box',
				render: function(h) {
					return (
						<MsMessageBox
							ref="msgBox"
							option={optionDefault}
							//  {...vv}
						>
							{' '}
						</MsMessageBox>
					);
				},
				computed: {},
				methods: {},
				components: {
					MsMessageBox
				}
			});
			// nhận sự kiện click vào button
			let msgBox = zz.$refs.msgBox;
			if (msgBox) {
				msgBox.$on('btnClick', function(msg, action) {
					resolve(action);
				});
				// hngiap - 26.05.2020: Bổ sung callback thêm tham số resolve, reject để
				// - Xử lý trường hợp await action của msgBox cần resolve để chạy tiếp
				msgBox.$on('linkActive', function() {
					resolve('linkActive');
				});

				msgBox.$on('btnCloseClick', function() {
					resolve('btnCloseClick');
				});

				msgBox.$on('linkPopup', this.customLinkPopup);
			}
		});

		return promise;
	}

	customLinkActive(resolve, reject) {}

	customLinkPopup() {}
	/**
	 * Hàm hiện thị message box câu hỏi
	 * @param {Message cần hiển thị ra} message
	 * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
	 */
	showQuestion(message, customOptions) {
		// cấu hình mặc định với msg Question
		let option = {
			message: message,
			messageDetail: null,
			line: true,
			close: true,
			btnConfig: [
				{
					key: 'No',
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.ClosePop')}`,
					typeButton: 'secondary'
				},
				{
					key: 'Yes',
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.Agree')}`,
					focus: true,
					typeButton: 'primary'
				}
			]
		};
		if (customOptions) {
			option = { ...option, ...customOptions };
		}
		return this.show(option);
	}

	/**
	 * Hàm hiện thị message box cảnh báo
	 * @param {Message cần hiển thị ra} message
	 * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
	 */
	showWarning(message, messageDetail, customOptions) {
		//Cấu hình mặc định với msgWarning
		let option = {
			message: message,
			messageDetail: messageDetail,
			icon: 'mi-icon-waring-55',
			line: true,
			close: true,
			title: `${i18n.t('i18nCommon.Notification')}`,
			btnConfig: [
				{
					key: 'Close',
					target: 'Center',
					text: `${i18n.t('i18nCommon.Close')}`,
					focus: true
				}
			],
			errorText: i18n.t('i18nCommon.ErrorNeedContaxMisa')
		};

		//Gán cảnh báo mặc định nếu không tồn tại
		if (!option.message || option.message == undefined || option.message == 'undefined') {
			option.message = option.errorText;
		}

		if (customOptions) {
			option = { ...option, ...customOptions };
		}
		return this.show(option);
	}

	/**
	 * Hàm hiện thị message box lỗi
	 * @param {Message cần hiển thị ra} message
	 * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
	 */
	showError(message, messageDetail, title, customOptions) {
		// cấu hình mặc định với msg Error
		let option = {
			message: message,
			messageDetail: messageDetail == '' ? messageDetail : null,
			icon: 'mi-exclamation-error-48',
			line: true,
			title: title,
			btnConfig: [
				{
					key: 'Close',
					target: 'Center',
					text: `${i18n.t('i18nCommon.Close')}`,
					focus: true
				}
			]
		};
		if (customOptions) {
			option = { ...option, ...customOptions };
		}
		return this.show(option);
	}

	/**
	 * Hàm hiện thị message box thông tin
	 * @param {Message cần hiển thị ra} title
	 * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} message
	 */
	showInfo(title, message, customOptions = {}) {
		// cấu hình mặc định với info
		let option = {
			message: message,
			icon: 'mi-exclamation-info-48',
			line: true,
			title: title,
			btnConfig: [
				{
					key: 'Close',
					target: 'Center',
					text: `${i18n.t('i18nCommon.Close')}`,
					focus: true
				}
			]
		};
		if (customOptions) {
			option = { ...option, ...customOptions };
		}
		return this.show(option);
	}

	/**
	 * Hàm hiện thị message box xác nhận
	 * @param {Message cần hiển thị ra} message
	 * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
	 */
	async showConfirm(message, customOptions) {
		// cấu hình mặc định với msg confirm
		let option = {
			message: message,
			messageDetail: null,
			icon: 'mi-icon-waring-55',
			line: true,
			btnConfig: [
				{
					key: 'No',
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.No')}`
				},
				{
					key: 'Yes',
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.Yes')}`,
					focus: true
				}
			]
		};
		if (customOptions) {
			option = { ...option, ...customOptions };
		}
		return this.show(option);
	}

	/**
	 * Hàm hiện thị message box xác nhận Có không
	 * @param {Message cần hiển thị ra} message
	 * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
	 */
	async showConfirmNext(message, customOptions) {
		// cấu hình mặc định với msg confirm
		let option = {
			message: message,
			messageDetail: null,
			icon: 'mi-icon-waring-55',
			line: true,
			btnConfig: [
				{
					key: 'No',
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.No')}`
				},
				{
					key: 'Yes',
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.Yes')}`,
					focus: true
				}
			]
		};
		if (customOptions) {
			option = { ...option, ...customOptions };
		}
		return this.show(option);
	}

	/**
	 * Hàm hiện thị message box thành công
	 * @param {Message cần hiển thị ra} message
	 * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
	 * created by ntphong 19/3/2020
	 */
	showSuccess(message, messageDetail) {
		// cấu hình mặc định với info
		let option = {
			message: message,
			messageDetail: messageDetail,
			icon: 'mi-exclamation-success',
			line: true,
			btnConfig: [
				{
					key: 'Close',
					target: 'Center',
					text: `${i18n.t('i18nCommon.Close')}`,
					focus: true
				}
			]
		};
		return this.show(option);
	}

	close() {
		// Tìm msgBox instance hiện tại và đóng nó
		const msgBoxEl = document.querySelector('#message-box');
		if (msgBoxEl) {
			const vueInstance = msgBoxEl.getVueInstance();
			if (vueInstance) {
				vueInstance.isShowMessage = false;
			}
		}
	}
}

export default new MessageBox();
